export default {
  E_PROCEDURE: 'eprocedure',
  PROCEDURE: 'procedure',
  E_MEASURE: 'emeasure',
  MEASURE: 'measures',
  E_LAB: 'elab',
  LAB: 'lab',
  E_DIAGNOSIS: 'ediagnosis',
  DIAGNOSIS: 'diagnosis',
  E_MEDICATION: 'emedication',
  MEDICATION: 'med',
  E_VACCINE: 'evax',
  VACCINE: 'vaccine',
  E_ALLERGY: 'eallergy',
  ALLERGY: 'allergy',
  E_OTHER: "eother",
  OTHER: "other",
  REPORT: 'report'
}